export const SET_CAMPAIGNS = 'SET_CAMPAIGNS'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_SELLERS = 'SET_SELLERS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js